import customAxios from "../index";

export interface ProviderDashboardQuery {
  timezone: string;
  startDate: string;
  endDate: string;
  sortBy?: string;
  sortDirection?: "asc" | "desc";
}

export type ProviderDashboardExportSection =
  | "providerMyBookings"
  | "providerMyServices"
  | "providerMyEarnings";

export interface ProviderDashboardExportQuery extends ProviderDashboardQuery {
  section: ProviderDashboardExportSection;
}

export const getProviderDashboardData = (
  params: ProviderDashboardQuery,
  token?: string
) => {
  return customAxios({
    method: "GET",
    url: "/provider-dashboard/dashboard-reports",
    params,
    ...(token
      ? {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      : {}),
  });
};

export const exportProviderDashboardSection = (
  params: ProviderDashboardExportQuery,
  token?: string
) => {
  return customAxios({
    method: "GET",
    url: "/provider-dashboard/dashboard-reports/export",
    params,
    ...(token
      ? {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      : {}),
  });
};
